@if (!editMode && !loading) {
  <div class="editable-text" (click)="click()">
    @if (!hasText()) {
      <span class="missing text-nowrap">⚠️ Missing translation</span>
    }
    {{ text }}
  </div>
}
@if (!editMode && loading) {
  <div class="spinner-border text-warning" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
}
@if (editMode) {
  <textarea class="w-100 form-control mb-2" [(ngModel)]="text" #textAreaElement></textarea>
  <button class="btn btn-sm btn-primary fw-bold" (click)="save()">OK</button>
  <button class="btn btn-sm btn-primary ms-2" (click)="cancel()">Cancel</button>
}
